<template>
  <div>
    <div class="box_bg">
      <div class="main">
        <Header style="z-index: 99" />
        <div class="slideIcon" @mouseover="open" >
          <img  class="slide" src="../../../assets/images/leftSilde.png" alt="" >
          <!-- <img class="slide" src="../../../assets/images/slide.png" alt="" > -->
        </div>
        <el-aside 
	          style="width:210px;position:absolute;z-index:9999;height:890px" 
	          :class="{'open':!isCollapse}" 
	          ref="leftAside">
          	<LeftNav></LeftNav>
        </el-aside>
        <div class="popContainer" 
        		ref="msk" 
        		v-if="!isCollapse"
        		@click="closeMenu($event)">
        </div>
        <router-view :style="height" />
      </div>
    </div>
  </div>
</template>

<script>
const name = "Layout";
import Header from "@/components/layout/header/Index";
import LeftNav from "./LeftNav.vue";
export default {
  name: name,
  data() {
    return {
      height: {
        "z-index": 97,
        width: "100%",
        height: "",
        "overflow-y": "auto",
      },
      isCollapse:true,
    };
  },
  methods: {
    setHeights() {
      this.height.height = window.innerHeight - 71 + "px";
    },
    open() {
      this.isCollapse = false;
    },
    closeMenu(ev){
      if (this.$refs.msk.contains(ev.target)) {
        this.isCollapse = true;
      }
    }
  },
  mounted() {
    window.onresize = () => {
      this.setHeights();
    };
    this.setHeights();
  },
  components: { Header, LeftNav },
};
</script>
<style lang="scss">
.main {
  // margin-left: 210px;
  transition: margin-left 0.3s;
  min-height: 100%;
}
.mobile {
  .main {
    margin-left: 0px;
  }
}
.main-nav-hide {
  margin-left: 0px !important;
}
.nav-hide {
  width: 0px !important;
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 100;
}
/* 组件切换动画 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.2s;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-10px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(10px);
}
.popContainer{
      position: fixed;
      top: 70px;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 998;
      background: rgba(0,0,0,0.2);
      transition: opacity 1s ease-in-out 1s;
  }
.slideIcon{
    padding: 5px 5px;
    position: fixed;
    // background-color: #000;
    height: 880px;
    border-radius: 4px;
    position: absolute;
    // top: 85px;
    // left: 20px;
    // border: 1px solid #000;
    cursor: pointer;
  }
.slide{
  // width: 5px;
  height:20px;
}

.el-aside{
    left:-250px;
    transition:left .3s ease-in-out;
}
.open{
  left:0;
}

</style>

